import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { EvCore } from "ev-core";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { EVNDSaleStateType } from "src/models/new-dwelling/new-dwelling.enums";
import { ConvertUtil } from "src/util/tools/convert.util";

@Component({
    selector: "new-dwelling-map-marker",
    imports: [EvCore],
    templateUrl: "./new-dwelling-map-marker.component.html",
    styleUrls: ["./new-dwelling-map-marker.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingMapMarkerComponent {
    readonly data = input<IProjectStageDto | null>(null);

    estateTypeCssClass = computed(() => ConvertUtil.estateTypesToCssClass(this.data()?.estateTypes ?? []));

    EVNDSaleStateType = EVNDSaleStateType;

}
